import { render, staticRenderFns } from "./wechatbind.vue?vue&type=template&id=35bc96f1&"
import script from "./wechatbind.vue?vue&type=script&lang=ts&"
export * from "./wechatbind.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports